import { useAuth } from "../context/AuthContext";
import { UserX } from "lucide-react";

export default function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonating } = useAuth();
  if (!isImpersonating) return null;

  return (
    <div className="bg-amber-500 text-black px-4 py-2 flex items-center justify-between text-sm font-medium">
      <div className="flex items-center gap-2">
        <UserX size={16} />
        <span>Impersonating <strong>{user?.name}</strong> ({user?.email})</span>
      </div>
      <button
        onClick={stopImpersonating}
        className="bg-black text-white text-xs px-3 py-1 hover:bg-gray-800 transition-colors"
      >
        Stop Impersonating
      </button>
    </div>
  );
}
